import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from "src/environments/environment";
import { ApiErrorHandlerService } from "./api-error-handler.service";
import { Orgao } from "../model/orgao.model";

@Injectable({
    providedIn: 'root'
})
export class OrgaoService {

    private baseUrl = `${environment.apiUrl}/orgao`;

    constructor(
        private http: HttpClient,
        private errorHandler: ApiErrorHandlerService
    ) { }

    getAtivos(): Observable<Orgao[]> {
        const url = `${this.baseUrl}/listar/ativos`;
        return this.http.get<Orgao[]>(url).pipe(catchError(this.errorHandler.handle()));
    }

    /**
     * Ativos e inativos.
     */
    getTodos(): Observable<Orgao[]> {
        const url = `${this.baseUrl}/listar/todos`;
        return this.http.get<Orgao[]>(url).pipe(catchError(this.errorHandler.handle()));
    }
}
